const options = {
	animationDuration: 750,
	gridScale: 1,
	fullscreenUgcScale: 3.2, // optimal screen size (for this implementation 1080) / height of the PhotoBoxWrapper
	fullscreenShoutScale: 1.55,
	maxSelectedCount: 6,
	randomSwitchInterval: 6000,
	minWiggleAngle: 1.5,
	maxWiggleAngle: 1.5,
	minUserWiggleAngle: 4,
	maxUserWiggleAngle: 4,
	minWiggleDuration: 2000,
	maxWiggleDuration: 3000,
	fullscreenWiggleDuration: 2500,
};

export default options;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/animatedVisualizations/options.js